export const SELECT_ITEM_DEFAULT = { value: null, label: '-- Select --' };
export const DATE_FORMAT = 'DD/MM/YYYY';
export const FOTNT_SIZE = 14;
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const DATA_FROM_YEAR = 2000;
export const DEFAULT_NULL_VALUE = 'Chưa xác định';
export const AGGREGATORS = ['Count', 'Sum', 'Average', 'Minimum', 'Maximum'];

export function initAppJson(appConfig) {
  window.config = appConfig;
}

export function getConfigFromApp() {
  return window.config ? window.config : {};
}

export function getWindowConfig() {
  const appConfig = getConfigFromApp();
  return {
    apiService: appConfig.serviceApi + '/',
    storagePath: `${appConfig.serviceApi}/FileDatabase/`,
    googleApiKey: appConfig.googleApiKey
      ? appConfig.googleApiKey
      : 'AIzaSyDYJUaT4MfndXXbkz0TkMb9keTQGcAOMcI',
    role: {
      isModuleEmission:
        appConfig.isModuleEmission &&
        appConfig.isModuleEmission.toLowerCase() === 'false'
          ? false
          : true,
      isModuleMap:
        appConfig.isModuleMap && appConfig.isModuleMap.toLowerCase() === 'false'
          ? false
          : true,
      isModuleMonitoring:
        appConfig.isModuleMonitoring &&
        appConfig.isModuleMonitoring.toLowerCase() === 'false'
          ? false
          : true,
      isModuleProtectFee:
        appConfig.isModuleProtectFee &&
        appConfig.isModuleProtectFee.toLowerCase() === 'false'
          ? false
          : true,
      isModuleMonitoringReport:
        appConfig.isModuleMonitoringReport &&
        appConfig.isModuleMonitoringReport.toLowerCase() === 'false'
          ? false
          : true,
      isModuleWasteReport:
        appConfig.isModuleWasteReport &&
        appConfig.isModuleWasteReport.toLowerCase() === 'false'
          ? false
          : true,
      isModuleReport:
        appConfig.isModuleReport &&
        appConfig.isModuleReport.toLowerCase() === 'false'
          ? false
          : true,
      isModuleFacilityeia:
        appConfig.isModuleFacilityeia &&
        appConfig.isModuleFacilityeia.toLowerCase() === 'false'
          ? false
          : true,
      isModuleFacilityDevice:
        appConfig.isModuleFacilityDevice &&
        appConfig.isModuleFacilityDevice.toLowerCase() === 'false'
          ? false
          : true,
      isModuleFacilityAudit:
        appConfig.isModuleFacilityAudit &&
        appConfig.isModuleFacilityAudit.toLowerCase() === 'false'
          ? false
          : true,
      isModuleBiodiversity:
        appConfig.isModuleBiodiversity &&
        appConfig.isModuleBiodiversity.toLowerCase() === 'false'
          ? false
          : true,
      isModuleEnvironmentProtectionWork:
        appConfig.isModuleEnvironmentProtectionWork &&
        appConfig.isModuleEnvironmentProtectionWork.toLowerCase() === 'false'
          ? false
          : true,
      isModuleLegalDocument:
        appConfig.isModuleLegalDocument &&
        appConfig.isModuleLegalDocument.toLowerCase() === 'false'
          ? false
          : true,
    },
  };
}

export const IS_ENTERPRISE = process.env.REACT_APP_USER_TYPE === 'enterprise';

export const COLOR = {
  SUCCESS: '#1890FF',
  REQUIREDFIELD: '#660000',
  MENU_COLOR: 'linear-gradient(270deg, #56D2F3 0%, #2BA6E3 100%)',
  MENU_ACTIVE_COLOR: '#79D1F3',
  TEXT_COLOR: '#FFFFFF',
  PRIMARY_COLOR: '#1890FF',
  SECOND_COLOR: '#4BA9FF',
};

export const STYLE = {
  REQUIREDFIELD: {
    color: COLOR.REQUIREDFIELD,
    fontWeight: 700,
  },
};



// WEBPACK FOOTER //
// ./src/config.js